import { ITreeViewModelConverter } from "../../Components/TreeView/Models/Interfaces/ITreeViewModelConverter";
import { ITreeNodeModel } from "../../Components/TreeView/Models/Interfaces/ITreeNodeModel";
import { TreeNodeModel } from "../../Components/TreeView/Models/TreeNodeModel";
import { ITreeField } from "./ITreeField";

export class AvailableFieldsConverter implements ITreeViewModelConverter {
    flatNodes: ITreeNodeModel[] = [];

    convertModel = (model: any, selectedIds: number[]): ITreeNodeModel[] => {
        let typedModel = model as ITreeField;
        let tree: ITreeNodeModel[] = [];
        this.flatNodes = [];

        for (let item of typedModel.childs) {
            this.addToTree(tree, item, undefined);
        }

        return tree;
    }

    addToTree = (tree: ITreeNodeModel[], item: ITreeField, parent: ITreeNodeModel) => {
        const node = new TreeNodeModel();
        node.businessModel = item;
        node.children = [];
        node.parent = parent;
        node.displayProperty = "name";
        tree.push(node);
        this.flatNodes.push(node);

        if (item.childs) {
            for (let sub of item.childs) {
                this.addToTree(node.children, sub, node);
            }
        }
    }

    getFlatNodes = (): ITreeNodeModel[] => {
        return this.flatNodes;
    }
}
